import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 8px 0;
  margin-bottom: 8px;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const DateCard = styled.div<{ isActive: boolean }>`
  min-width: 64px;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.isActive ? "#0FA457" : "#E7E7F0")};
  background-color: ${(props) => (props.isActive ? "#F3FAF7" : "#FFFFFF")};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.isActive ? "#0FA457" : "#D0D0D8")};
  }
`;

export const DayLabel = styled.div<{ isActive: boolean }>`
  font-size: 11px;
  font-weight: 500;
  color: ${(props) => (props.isActive ? "#0FA457" : "#8B90A1")};
  text-align: center;
  line-height: 14px;
`;

export const DateNumber = styled.div<{ isActive: boolean }>`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => (props.isActive ? "#0FA457" : "#2C2C3A")};
  text-align: center;
  line-height: 24px;
`;

export const SlotCount = styled.div<{ isActive: boolean }>`
  font-size: 11px;
  font-weight: 400;
  color: ${(props) => (props.isActive ? "#0FA457" : "#555A68")};
  text-align: center;
  line-height: 14px;
`;

